<template>
  <div class="fabric-spec-container">
    <div>
      <div class="spec_wrapper d-flex">
        <div class="div_border" style="min-width:240px">
          <div class="div_no">
            {{ '适用范围' }}
          </div>
        </div>

        <div
          class="d-flex justify-content-between align-items-center"
          style="width:100%"
        >
          <div class="div_title" style="margin-left: 10px;">
            {{ '面料颜色或花型' }}
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div style="min-width:240px;" class="div_border">
          <div class="spec">
            <div class="spec_title " style="">
              <div class="weight_8 mt-2">
                {{ '适用产品颜色' }}
              </div>
              <div class="mt-1">
                {{ '蓝白色 Blue/White' }}
              </div>
              <div class="weight_8 mt-2">
                {{ '适用产品尺寸' }}
              </div>
              <div class="mt-1">
                {{ '18"x18"、20"x20"' }}
              </div>
              <div class="weight_8 mt-5">
                {{ '面料工厂' }}
              </div>
              <div class="mt-1">
                {{ '大连丰深科贸有限公司' }}
              </div>
              <div class="weight_8 mt-2">
                {{ '工厂业务' }}
              </div>
              <div class="mt-1">
                {{ 'Zhangxu-张旭' }}
              </div>
              <div class="weight_8 mt-2">
                {{ '具体说明' }}
              </div>
              <div class="mt-1">
                <div>{{ '经纱：雪尼尔（白色）' }}</div>
                <div>{{ '纬纱：雪尼尔+桑子纱加粗' }}</div>
                <div>{{ '四角流苏，2PC' }}</div>
              </div>
            </div>
          </div>
        </div>

        <div :class="{ spec_card: true, fabric_back: !isEmpty }">
          <FabricInfo
            v-if="!isEmpty"
            :fabricList="specInfo.content"
          ></FabricInfo>
          <div v-if="isEmpty" class="no-data__wrapper">
            <div style="text-align: center">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">
                {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FabricInfo from '../fabric-info'
import EditLoading from '@/mixins/edit-loading'
export default {
  props: {
    specInfo: { type: Object, default: () => {} },
  },
  mixins: [EditLoading],
  components: { FabricInfo },
  data() {
    return {}
  },
  computed: {
    isEmpty() {
      return !this.specInfo.content.length
    },
    evgSkuSpecCode() {
      return this.specInfo.evgSkuSpecCode
    },
  },

  methods: {},
}
</script>
<style lang="scss" scoped>
.fabric-spec-container {
  border: 1px solid #efefef;
  margin-bottom: 10px;
}
.no-data__wrapper {
  padding: 30px 0;
}

.spec_wrapper {
  height: 41px;
  background-color: #fafafa;

  .div_no {
    line-height: 43px;
    font-weight: 600;
    color: #303133;
    font-size: 14px;
    margin-left: 10px;
  }
  .div_title {
    line-height: 43px;
    font-weight: 600;
    color: #4f4f4f;
    font-size: 14px;
  }
}
.fabric_back {
  background-color: #efefef;
}
.spec {
  margin-top: 11px;
  margin-left: 10px;
  // height: 370px;
  // overflow-y: auto;
}
.radius {
  border-radius: 5px !important;
}
.weight_8 {
  font-weight: 800;
}
.spec_card {
  width: 100%;
  // height: 370px;
  // overflow-y: auto;
}
.div_border {
  border-right: 1px solid #efefef;
}
.spec_title {
  font-size: 14px;
  text-align: left;
  color: #4f4f4f;
}
.b-b1 {
  border-bottom: 1px solid #efefef;
}
.p-10 {
  padding: 5px 10px;
}
.w-full {
  width: 100%;
}
.fabric-info-container {
  padding: 0px 10px 10px 10px;
}
</style>
